// extracted by mini-css-extract-plugin
export var parcelRow = "_r0-0";